<template>
  <sModal
    ref="dialog"
    v-model="open"
    :data-qa="dataQa"
    :fullscreen="fullscreen"
    :loading="loading"
    :mask-closable="false"
    :retain-focus="retainFocus"
    :title="title"
    :width="width || 736"
    @close="$emit('close')">
    <template v-slot:activator="{ visible: show }">
      <slot
        name="activator-btn"
        :show="show"
        v-on="open = true"/>
    </template>
    <slot name="card-text"/>
    <template #footer>
      <slot name="card-actions">
        <div
          key="footer"
          class="flex"
          :class="footer_class"
          :data-qa="dataQa ? `${dataQa}_footer` : 'dialog-template-footer'">
          <slot name="first_btn">
            <sButton
              v-if="!without_first_btn"
              :data-qa="dataQa ? `${dataQa}_btn-dialog-template-first` : 'btn-dialog-template-first'"
              :disabled="disabled"
              :loading="loading"
              @click="$emit('apply')">
              {{ $t(`${first_btn || 'Common.Apply'}`) }}
            </sButton>
          </slot>
          <slot name="second_btn">
            <sButton
              v-if="!without_second_btn"
              class="ml-2"
              :data-qa="dataQa ? `${dataQa}_btn-dialog-template-second` : 'btn-dialog-template-second'"
              :disabled="loading"
              :icon="img ? 'draft' : ''"
              icon-class="mr-2"
              type="text"
              @click="img || second_action ? $emit('action') : $emit('close')">
              {{ secondBtnLabel }}
            </sButton>
          </slot>
          <slot name="in-footer"/>
        </div>
      </slot>
    </template>
  </sModal>
</template>
<script>
export default {
  name: 'DialogTemplateToolkit',
  props: {
    dialog: Boolean,
    dataQa: String,
    footer_class: String,
    second_btn: String,
    title: String,
    loading: Boolean,
    disabled: Boolean,
    first_btn: String,
    img: Boolean, // только в acceptingDialog
    without_first_btn: Boolean,
    without_second_btn: Boolean,
    second_action: Boolean,
    fullscreen: Boolean,
    width: [String, Number],
    retainFocus: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    secondBtnLabel() {
      return this.$t(this.second_btn || (this.first_btn === 'Common.Cancel' ? 'Common.Close' : 'Common.Cancel'))
    },
    open: {
      get() {
        return this.dialog
      },
      set(value) {
        if (value) { this.$emit('open') }
        this.$emit('update:dialog', value)
      }
    },
  },
}
</script>

